import './NotFound.scss';

export default function NotFound()
{
    return (
        <div id="notFound">notfound</div>
    )
}